<template>
  <Modal
    :tracking="{
      topicKey: 'location-blocked-for-android',
    }"
    @cancel="emit('cancel')"
    @confirm="emit('confirm')"
  >
    <template #headline>
      {{ $t('restriction.android.title') }}
    </template>
    <p>
      {{ $t('restriction.android.text') }}
    </p>
    <template #confirm>
      {{ $t('restriction.android.cta.primary') }}
    </template>
    <template #cancel>
      {{ $t('restriction.android.cta.secondary') }}
    </template>
  </Modal>
</template>

<script lang="ts" setup>
const emit = defineEmits<{ (e: 'cancel' | 'confirm'): void }>()
</script>
